RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.DualGraphFooter = Marionette.ItemView.extend({
        events: {
            'click a': 'onLinkClicked'
        },
        template: '#dualGraphFooterTemplate',
        onLinkClicked: function (e) {
            const me = this;

            // first things first: stop the normal browser behavior,
            // as we will be taking care of things (like page navigation) ourselves
            e.preventDefault();
            e.stopPropagation();
            me.showDetails();

        },
        showDetails: function () {
            const me = this;
            const model = me.model;

            const click = model.get('click');

            if (typeof click === 'function') {
                click(me);
            }

            const href = model.get('href');

            if (href) {
                window.location = href;
            }
        }
    });
});
